import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AIIntegrationPage from "@/pages/service/AIIntegrationPage";

export const Route = createFileRoute("/service/ai-integration")({
  head: () => pageHead("AI Integration & Development", "Custom AI model development, generative AI solutions, and seamless integration of AI capabilities into enterprise systems.", "/service/ai-integration", false),
  component: AIIntegrationPage,
});
